module.exports = __webpack_public_path__ + "img/Proliferation-BRCA_10X_Section1.40d5a72e.png";